import React from 'react';
import { cn } from '@/lib/utils/cn';
import { useDataView } from './data-view';
import { DataViewListCardSkeleton, DataViewGridCardSkeleton } from './generic-card';

interface DataViewLoadingStateProps {
  className?: string;
  itemCount?: number;
}

export function DataViewLoadingState({ className, itemCount = 8 }: DataViewLoadingStateProps) {
  const { viewMode } = useDataView();

  if (viewMode === 'list') {
    return (
      <div className={cn("flex flex-col border border-gray-200 rounded-xl overflow-hidden bg-white", className)}>
        {Array.from({ length: itemCount }).map((_, i) => (
          <DataViewListCardSkeleton key={i} />
        ))}
      </div>
    );
  }

  // Grid Skeleton
  return (
    <div className={cn("grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4", className)}>
      {Array.from({ length: itemCount }).map((_, i) => (
        <DataViewGridCardSkeleton key={i} />
      ))}
    </div>
  );
}

